import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Chip, Typography } from "@mui/material";

const defTimeline = [
  {
    name: "Bob",
    data: [
      {
        x: "Design",
        y: [new Date("2019-03-05").getTime(), new Date("2019-03-08").getTime()],
      },
      {
        x: "Code",
        y: [new Date("2019-03-02").getTime(), new Date("2019-03-05").getTime()],
      },
      {
        x: "Code",
        y: [new Date("2019-03-05").getTime(), new Date("2019-03-07").getTime()],
      },
      {
        x: "Test",
        y: [new Date("2019-03-03").getTime(), new Date("2019-03-09").getTime()],
      },
      {
        x: "Test",
        y: [new Date("2019-03-08").getTime(), new Date("2019-03-11").getTime()],
      },
      {
        x: "Validation",
        y: [new Date("2019-03-11").getTime(), new Date("2019-03-16").getTime()],
      },
      {
        x: "Design",
        y: [new Date("2019-03-01").getTime(), new Date("2019-03-03").getTime()],
      },
      {
        x: "Design",
        y: [new Date("2019-04-01").getTime(), new Date("2019-04-03").getTime()],
      },
    ],
  },
  {
    name: "Joe",
    data: [
      {
        x: "Design",
        y: [new Date("2019-03-02").getTime(), new Date("2019-03-05").getTime()],
      },
      {
        x: "Test",
        y: [new Date("2019-03-06").getTime(), new Date("2019-03-16").getTime()],
        goals: [
          {
            name: "Break",
            value: new Date("2019-03-10").getTime(),
            strokeColor: "#CD2F2A",
          },
        ],
      },
      {
        x: "Code",
        y: [new Date("2019-03-03").getTime(), new Date("2019-03-07").getTime()],
      },
      {
        x: "Deployment",
        y: [new Date("2019-03-20").getTime(), new Date("2019-03-22").getTime()],
      },
      {
        x: "Design",
        y: [new Date("2019-03-10").getTime(), new Date("2019-03-16").getTime()],
      },
    ],
  },
  {
    name: "Dan",
    data: [
      {
        x: "Code",
        y: [new Date("2019-03-10").getTime(), new Date("2019-03-17").getTime()],
      },
      {
        x: "Validation",
        y: [new Date("2019-03-05").getTime(), new Date("2019-03-09").getTime()],
        goals: [
          {
            name: "Break",
            value: new Date("2019-03-07").getTime(),
            strokeColor: "#CD2F2A",
          },
        ],
      },
    ],
  },
];
export function TeamActivities({ timeline, title, pages, page, onPageChange }) {
  const [series, setSeries] = useState(timeline);

  const [options, setOptions] = useState({
    chart: {
      height: 450,
      type: "rangeBar",
      toolbar: {
        show: true,
        tools: {
          download: true,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "80%",
      },
    },
    xaxis: {
      type: "datetime",
    },
    stroke: {
      width: 1,
    },
    fill: {
      type: "solid",
      opacity: 0.6,
    },
    legend: {
      position: "top",
      horizontalAlign: "left",
    },
  });

  useEffect(() => setSeries(timeline), [timeline]);

  return (
    <div className={"break-words bg-white w-full mb-6 shadow-lg rounded p-5"}>
      <div>
        <Typography variant={"h5"}>{title}</Typography>
      </div>
      {series?.length && series[0]?.data?.length ? (
        <Chart options={options} series={series} type="rangeBar" height={450} />
      ) : (
        <div className={"p-5 text-center"}>
          <Typography variant={"h6"}>No Project founds !</Typography>
        </div>
      )}
      <div className={"flex justify-end"}>
        {pages?.map((v) => (
          <div className={"mr-2"}>
            <Chip
              color={page === v ? "primary" : undefined}
              label={v}
              clickable={true}
              onClick={() => onPageChange(v)}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
